import React from 'react';
import './TaskProgress.css';
import { Step } from '../types'; // Importaremos este tipo que crearemos

interface TaskProgressProps {
  steps: Step[];
  logs: string[];
}

const TaskProgress: React.FC<TaskProgressProps> = ({ steps, logs }) => {
  const getIconForStep = (step: Step) => {
    if (step.status === 'completed') return '✅';
    if (step.status === 'running') return <div className="spinner-inline"></div>;
    return '⏳';
  };

  return (
    <div className="task-progress">
      {steps.map((step) => (
        <div key={step.id} className={`task-step status-${step.status}`}>
          <div className="task-icon">{getIconForStep(step)}</div>
          <div className="task-content">{step.content}</div>
        </div>
      ))}
      {logs.length > 0 && (
        <div className="logs-container">
          <h4>Logs de Proceso:</h4>
          <div className="logs-content">
            {logs.map((log, index) => (
              <pre key={index}>{log}</pre>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskProgress;